var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeniALogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 125,
    viewBox: "0 0 187 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28721_58)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8614 95.4138H40.5777V111.931C40.5777 122.58 35.8426 125 24.1548 125H16.3629C4.61519 125 0 122.398 0 111.931V87.0643C0 78.6543 3.3565 74.3586 11.508 74.0561C14.0853 73.9956 16.7825 73.9351 19.5996 73.9351H36.8616V82.8896H20.1989C12.7667 82.8896 10.4291 83.3131 10.4291 89.0004V106.788C10.4291 113.444 10.549 116.106 16.9623 116.106H24.0349C29.0697 116.106 30.6281 114.412 30.6281 109.995V104.308H17.8614V95.4138Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6533 99.8911C44.6533 91.8442 47.3505 88.335 55.3222 88.335H70.4264C78.3981 88.335 81.0354 91.4206 81.3351 98.8626V102.977C81.3351 108.422 78.3382 111.145 72.2845 111.145H55.0225V114.351C55.0225 115.864 55.3222 116.893 56.461 117.377H80.1363V125H53.6439C47.4104 125 44.6533 121.854 44.6533 117.195V99.8911ZM58.9184 96.2609C56.3411 96.2609 55.0225 96.5029 55.0225 99.1046V103.219H68.2088C70.3066 103.219 71.0258 102.432 71.0258 100.436V99.1046C71.0258 96.9869 70.3066 96.2609 68.2088 96.2609H58.9184Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.783 125V102.553C111.783 98.8625 110.225 97.229 106.389 97.229H96.6788V125H86.3096V88.335H110.225C118.436 88.335 122.092 92.6307 122.092 100.678V125H111.783Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.367 71.0913H138.456V82.1634H127.367V71.0913ZM138.151 88.3348V125H127.662V88.3348H138.151Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.296 125H141.807L158.709 73.9351H169.378L187 125H176.51L172.674 113.444H155.952L152.296 125ZM158.889 104.308H169.618L164.163 87.7298L158.889 104.308Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0361 30.2515C52.7598 30.2515 46.0518 37.0228 46.0518 45.3773C46.0518 53.7318 52.7598 60.5032 61.0361 60.5032C65.936 60.5032 70.2915 58.1284 73.0236 54.4528C65.7462 48.9319 61.0361 40.1488 61.0361 30.2515Z",
    fill: "#F34D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0122 35.2936C84.0122 17.5006 98.3522 3.02517 115.979 3.02517H120.974V0H91.0049C74.4521 0 61.0361 13.5427 61.0361 30.2517H76.0205V45.3775C76.0205 48.7809 74.9067 51.927 73.0236 54.4531C78.0334 58.2496 84.2569 60.5034 91.0049 60.5034C92.5732 60.5034 94.1116 60.3824 95.6151 60.1454C88.5325 54.2211 84.0122 45.2817 84.0122 35.2936Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0205 30.2515H61.0361C61.0361 40.1488 65.7462 48.9319 73.0236 54.4528C74.9067 51.9268 76.0205 48.7806 76.0205 45.3773V30.2515Z",
    fill: "#F35F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.974 28.235H140.953V10.084H132.462H120.974V28.235Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.476 39.7001V42.8564H118.247C115.35 49.2244 110.335 54.4024 104.102 57.468C107.638 59.4041 111.684 60.5032 115.979 60.5032C129.75 60.5032 140.953 49.1941 140.953 35.2935H120.549C120.3 36.801 119.935 38.2732 119.476 39.7001Z",
    fill: "#F3A521"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.476 39.7001C119.94 38.2732 120.3 36.806 120.549 35.2935H119.476V39.7001Z",
    fill: "#F38221"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.101 57.4682C110.335 54.4078 115.35 49.2246 118.246 42.8567H112.482V28.235H120.974V10.084H115.979C102.208 10.084 91.0049 21.3931 91.0049 35.2937C91.0049 44.8583 96.3094 53.1927 104.101 57.4682Z",
    fill: "#F38221"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28721_58"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 125,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeniALogo);
export default __webpack_public_path__ + "static/media/GeniA_logo.04f52582b858702b5f403c99690fc264.svg";
export { ForwardRef as ReactComponent };